import React from "react";

export const AppContext = React.createContext({
  search: "all"
});



// WEBPACK FOOTER //
// ./src/lib/AppContext.js